/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React, { useRef } from 'react';
import Draggable from 'react-draggable';

const DRAG_HANDLE_CLASS = 'draggable-plugin-handle';

interface DraggablePluginProps {
  children: React.ReactNode;
  startTop?: number;
  startLeft?: number;
}

export const DraggablePlugin = ({
  children,
  startTop = 60,
  startLeft = 16,
}: DraggablePluginProps): React.JSX.Element => {
  const nodeRef = useRef<HTMLDivElement>(null!);

  return (
    <Draggable
      bounds="parent"
      handle={`.${DRAG_HANDLE_CLASS}`}
      nodeRef={nodeRef}
    >
      <div
        data-testid="draggable-plugin-wrapper"
        ref={nodeRef}
        style={{
          position: 'absolute',
          top: startTop,
          left: startLeft,
          zIndex: 1300,
          pointerEvents: 'all',
        }}
      >
        <div
          className={DRAG_HANDLE_CLASS}
          data-testid="draggable-plugin-handle"
          style={{
            height: '8px',
            cursor: 'grab',
            backgroundColor: 'rgba(0,0,0,0.15)',
            borderRadius: '4px 4px 0 0',
          }}
        />
        {children}
      </div>
    </Draggable>
  );
};
